import { Column } from '@/presentation/components/table';
import { AiFillFilePdf } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Report } from '../types/collections';

const CATEGORY_LABELS: Record<string, string> = {
  blasting: 'Cronograma de Voladura',
  meeting: 'Reporte de Seguridad de Reunión Diaria de Mina',
  brigades: 'Reporte de Entrenamiento de Brigadas',
  safety: 'Reportes de Entrenamiento de Seguridad',
  incidents: 'Sistema de Comando de Incidentes de Turno',
  maintenance: 'Reporte de Mantenimiento',
};

export const columnsReports: Column<Report>[] = [
  { header: 'Título', accessor: 'title' },
  {
    header: 'Categoría',
    accessor: 'category',
    render: (value) => {
      if (value && typeof value === 'string') {
        const label = CATEGORY_LABELS[value] ?? value;
        return <span>{label}</span>;
      }
      return <span>Sin categoría</span>;
    },
  },
  {
    header: 'Creado el',
    accessor: 'createdAt',
    render: (value) => {
      if (value && typeof value === 'object' && 'seconds' in value) {
        return (
          <span className="text-sm">
            {new Date(value.seconds! * 1000).toLocaleDateString('es-CO', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </span>
        );
      }
      return <span className="text-sm">Desconocido</span>;
    },
  },
  {
    header: 'Vistas',
    accessor: 'views',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Descargas',
    accessor: 'downloads',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Favoritos',
    accessor: 'favorites',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Comentarios',
    accessor: 'comments',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Documento',
    accessor: 'documentUrl',
    render: (value) =>
      value ? (
        <Link to={value.toString()} target="_blank" rel="noreferrer">
          <div className="flex justify-center items-center">
            <AiFillFilePdf className="text-red-500" size={24} />
          </div>
        </Link>
      ) : (
        <div className="flex justify-center items-center">
          <AiFillFilePdf className="text-gray-500" size={24} />
        </div>
      ),
  },
];
